import styled from 'styled-components';

export default styled.h1`
    margin-top: 0;
    margin-bottom: 14px;
    font-size: 14px;
    color: #465576;
    font-weight: 500;
`;
